import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoLabel from "../../raikoComponents/raikoCustomLabel/RaikoLabel";
import RaikoGridThreeColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridThreeColumn";
import React, {useEffect, useState} from "react";
import {SliderService} from "../../serverService/sliderService/SliderService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import RaikoConfirmDialog from "../../raikoComponents/raikoCustomDialogs/RaikoConfirmDialog";
import {RaikoAlert, raikoAlertTypes} from "../../raikoComponents/raikoAlert/RaikoAlert";
import RaikoToggleOutlined from "../../raikoComponents/raikoCustomInput/raikoToggleOutlined/RaikoToggleOutlined";

export default function SliderListGlobalInfo({id}) {

    const service = new SliderService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== "undefined" && id && id >= 0) {
            getDataFromServer()
        }
    }, [id])

    function getDataFromServer() {
        loading.show()
        service.getSliderDetail(id)
            .then((
                {
                    info,
                    publish
                }) => {

                setType(info.type.persianName)
                setDateCreated(convertUniversalDateToPersianDate(info.createdAt))
                setCreator(info.createdBy)

                setPublished(publish.published)

                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت جزئیات اسلایدر"))
            loading.hide()
        })
    }


    const [type, setType] = useState("");
    const [creator, setCreator] = useState("");
    const [dateCreated, setDateCreated] = useState("");

    const [published, setPublished] = useState(false);
    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false);

    function handleCloseConfirmDialog() {
        setConfirmDialogOpenState(false)
    }

    function handleOpenConfirmDialog() {
        setConfirmDialogOpenState(true)
    }

    function handleChangeEnableSetting() {
        loading.show()
        service.updateSliderPublishState(id, !published)
            .then(response => {
                setPublished(response.published)
                handleCloseConfirmDialog()
                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در تغییر وضعیت انتشار اسلایدر"))
            loading.hide()
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={handleCloseConfirmDialog}
                doAction={handleChangeEnableSetting}

                pageTitle={"انتشار اسلایدر"}
                warningTitle={"آیا از تغییر وضعیت این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={!published ? "انتشار" : "عدم انتشار"}
            />

            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoLabel text={"اطلاعات پایه"}/>
                        <RaikoGridThreeColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"دسته بندی"}
                                setValue={setType}
                                value={type}
                                disabled={true}/>
                            <RaikoSimpleInputOutlined
                                labelText={"سازنده"}
                                setValue={setCreator}
                                value={creator}
                                disabled={true}/>
                            <RaikoSimpleInputOutlined
                                labelText={"تاریخ ساخت"}
                                setValue={setType}
                                value={dateCreated}
                                disabled={true}/>
                        </RaikoGridThreeColumn>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoAlert
                            type={raikoAlertTypes.warning}
                            title={"وضعیت انتشار"}
                            description={[
                                "* با فعالسازی این مورد کاربران قادر به مشاهده ی این اسلایدر خواهند بود و در غیر این صورت اسلایدر تنها به عنوان پیش نویس در پنل مدیریت باقی خواهند ماند.",
                            ]}
                        />
                        <RaikoToggleOutlined
                            labelText={"انتشار (منتشر شده / در انتظار انتشار)"}
                            setChecked={state => {
                                handleOpenConfirmDialog()
                            }}
                            checked={published}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </>
    )
}